// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606011541/js/" + chunkId + "." + {"44":"bca3a8b1","225":"ff607306","481":"81079d65","486":"4628c0d3","770":"62a16d78"}[chunkId] + ".0.15088924251010127.chunk.js";
};